import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpPerformanceReportPage } from '@/features/pcmp/pages/PcmpPerformanceReportPage';
import { pcmpReportSearchSchema } from '@/features/pcmp/types/pcmpReports.types';

export const Route = createFileRoute('/_auth/pcmp/reports/performance/')({
  validateSearch: pcmpReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Performance Report">
      <Suspense fallback={<PageLoader />}>
        <PcmpPerformanceReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
